import * as React from "react";
const SvgBulletPoint = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 8, viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 4, fill: "#CFCDC9" }));
export default SvgBulletPoint;
